import React from 'react';
import { Box, Header, Toggle, Filter, Line, breakpoints, space } from '@generationtux/component-library';
import { makeColorFilters, makePatternFilters, makeCategoryFilters, mapFilterName } from '../../../utils/utils';
import styled from 'styled-components';

const FilterContainer = styled(Box)`
  > div {
    margin-bottom: 24px;
  }
  > div:last-child {
    display: flex;
    flex-direction: column;
  }
  @media (min-width: ${breakpoints['xl']}) {
    display: flex;
    > div {
      min-width: 25%;
      padding-right: 40px;
    }
    > div:last-child {
      padding-right: 0;
    }
  }
`;
const FilterWrap = styled(Box)`
  display: grid;
  grid-template-rows: repeat(${props => Math.ceil(props.itemCount / 2)}, auto);
  grid-template-columns: repeat(${props => (props.itemCount < 3 ? 1 : 2)}, 1fr);
  grid-auto-flow: ${props => (props.itemCount < 3 ? 'row' : 'column')};
  grid-row-gap: ${space[1]}px;
  @media (min-width: ${breakpoints['md']}) {
    grid-template-rows: repeat(${props => Math.ceil(props.itemCount / 3)}, auto);
    grid-template-columns: repeat(${props => (props.itemCount < 3 ? 1 : 3)}, 1fr);
  }
  @media (min-width: ${breakpoints['xl']}) {
    grid-column-gap: ${space[3]}px;
    grid-template-rows: repeat(7, auto);
    grid-template-columns: repeat(${props => (props.itemCount < 8 ? 1 : 2)}, 1fr);
  }
`;

const GalleryFilter = ({
  activeCollection,
  isBundle,
  colorFilter,
  setColorFilter,
  patternFilter,
  setPatternFilter,
  categoryFilter,
  setCategoryFilter,
}) => {
  const colorFilters = makeColorFilters(activeCollection, isBundle);
  const patternFilters = makePatternFilters(activeCollection, isBundle);
  const categoryFilters = makeCategoryFilters(activeCollection, isBundle);

  return (
    <>
      <Toggle
        isInitialStateOpen={[false, false, false, false, false, false]}
        backgroundColor="white"
        mb={1}
        trigger={
          <Box p={3} block>
            <Header type={6}>Filters</Header>
          </Box>
        }
        content={
          <FilterContainer p={3} pt={0}>
            {categoryFilters && categoryFilters.length > 1 && (
              <Box>
                <Header type={3} size={6} textColor="grayDark">
                  Category
                </Header>
                <Line lineColor="grayLighter" my={2} />
                <FilterWrap itemCount={categoryFilters.length}>
                  {categoryFilters.map(filter => (
                    <Filter
                      key={filter}
                      isActive={categoryFilter.indexOf(filter) > -1}
                      filterColor={'white'}
                      filterLabel={mapFilterName(filter)}
                      onClick={() =>
                        setCategoryFilter(
                          categoryFilter.indexOf(filter) > -1
                            ? [...categoryFilter.filter(a => a !== filter)]
                            : [...categoryFilter, filter]
                        )
                      }
                    />
                  ))}
                </FilterWrap>
              </Box>
            )}
            {patternFilters && patternFilters.length > 1 && (
              <Box>
                <Header type={3} size={6} textColor="grayDark">
                  Patterns
                </Header>
                <Line lineColor="grayLighter" my={2} />
                <FilterWrap itemCount={patternFilters.length}>
                  {patternFilters.map(filter => (
                    <Filter
                      key={filter}
                      isActive={patternFilter.indexOf(filter) > -1}
                      filterColor={'white'}
                      filterLabel={mapFilterName(filter)}
                      onClick={() =>
                        setPatternFilter(
                          patternFilter.indexOf(filter) > -1
                            ? [...patternFilter.filter(a => a !== filter)]
                            : [...patternFilter, filter]
                        )
                      }
                    />
                  ))}
                </FilterWrap>
              </Box>
            )}
            {colorFilters.length && colorFilters.length > 1 && (
              <Box className="filter-colors-wrap">
                <Header type={3} size={6} textColor="grayDark">
                  Colors
                </Header>
                <Line lineColor="grayLighter" my={2} />
                <FilterWrap itemCount={colorFilters.length}>
                  {colorFilters.map(filter => (
                    <Filter
                      key={filter}
                      isActive={colorFilter.indexOf(filter) > -1}
                      filterColor={filter === 'Brown' ? '#8a4038' : filter.toLowerCase()}
                      filterLabel={mapFilterName(filter)}
                      onClick={() =>
                        setColorFilter(
                          colorFilter.indexOf(filter) > -1
                            ? [...colorFilter.filter(a => a !== filter)]
                            : [...colorFilter, filter]
                        )
                      }
                    />
                  ))}
                </FilterWrap>
              </Box>
            )}
          </FilterContainer>
        }
      />
    </>
  );
};

export default GalleryFilter;
